export default __webpack_public_path__ + "static/media/clogo.5ad433ff.png";